import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model, OData, $data } from 'src/core/services/data/JayDataContext';

import { ContextService } from 'src/core/services/context.service';
import { FormatService } from "src/core/services/format.service";
import { computed } from 'mobx';

export class UserTaskSummariesDataService extends DataService<typeof Model.Rules.Logic.ViewModels.UserTaskSummary, Model.Rules.Logic.ViewModels.UserTaskSummary, UserTaskSummary> {

	constructor(contextService: any, entitySet: (context: OData.Container) => $data.EntitySet<typeof Model.Rules.Logic.ViewModels.UserTaskSummary, Model.Rules.Logic.ViewModels.UserTaskSummary>, private formatService: FormatService) {
		super(contextService, entitySet);
	}


	protected map(entity: Model.Rules.Logic.ViewModels.UserTaskSummary): UserTaskSummaryModel {
		return new UserTaskSummaryModel(entity, this.formatService);
	}
	static make(context: ContextService, formatService: FormatService): UserTaskSummariesDataService {
		return new UserTaskSummariesDataService(context, ctx => ctx.UserTaskSummaries, formatService);
	}
}

export class UserTaskSummaryModel extends EntityModel<Model.Rules.Logic.ViewModels.UserTaskSummary, UserTaskSummary> implements UserTaskSummary {


	constructor(entity: Model.Rules.Logic.ViewModels.UserTaskSummary, private formatService: FormatService) {
		super(entity);
	}


	@property<UserTaskSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<UserTaskSummaryModel>(o => o.entity.title, (o, value) => o.entity.title = value)
	public title: string;

	@property<UserTaskSummaryModel>(o => o.entity.body, (o, value) => o.entity.body = value)
	public body: string;
	
	@property<UserTaskSummaryModel>(o => o.entity.daedline, (o, value) => o.entity.daedline = value)
	public daedline: Date;

	@property<UserTaskSummaryModel>(o => o.entity.assignedToUserName, (o, value) => o.entity.assignedToUserName = value)
	public assignedToUserName: string;


	@property<UserTaskSummaryModel>(o => o.entity.assignedToId, (o, value) => o.entity.assignedToId = value)
	public assignedToId: number;

	@property<UserTaskSummaryModel>(o => o.entity.state, (o, value) => o.entity.state = value)
	public state: number;
	
	@property<UserTaskSummaryModel>(o => o.entity.priority, (o, value) => o.entity.priority = value)
	public priority: number;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	public dynamicProperties: {};


	@property<UserTaskSummaryModel>(o => o.entity.modelType, (o, value) => o.entity.modelType = value)
	public modelType: string;

	@property<UserTaskSummaryModel>(o => o.entity.modelId, (o, value) => o.entity.modelId = value)
	public modelId: string;

	@computed
	public get dateText(): string {
		return this.formatService.toString('date-time', this.daedline, 'utc');
	}
}



// WEBPACK FOOTER //
// ./src/app/general/user-tasks/list/user-task-list.data.ts